import { useTheme } from "@/theme/ThemeProvider";
import { Platform, Pressable, Text, View } from "react-native";

type KeyEvent = {
  key?: string;
  repeat?: boolean;
  nativeEvent?: { key?: string; repeat?: boolean };
  preventDefault?: () => void;
};

type Reason = { id: string; label: string };

type Props = {
  reasons: readonly Reason[];
  selected: ReadonlySet<string>;
  onToggle: (id: string) => void;
};

/** Aufnahmegründe als Checkboxen, 44 px hoch, nur checked. */
export function IntakeReasonChips({ reasons, selected, onToggle }: Props) {
  const { theme } = useTheme();
  return (
    <View
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: theme.space.sm,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
      }}
    >
      {reasons.map((reason) => {
        const checked = selected.has(reason.id);
        return (
          <Pressable
            key={reason.id}
            onPress={() => onToggle(reason.id)}
            {...(Platform.OS === "web"
              ? {
                  "aria-checked": checked,
                  onKeyDown: (event: KeyEvent) => {
                    if (event.repeat ?? event.nativeEvent?.repeat) return;
                    const key = event.key ?? event.nativeEvent?.key;
                    if (key !== " " && key !== "Spacebar") return;
                    event.preventDefault?.();
                    onToggle(reason.id);
                  },
                }
              : {})}
            accessibilityRole="checkbox"
            accessibilityLabel={reason.label}
            accessibilityState={{ checked }}
            style={{
              minHeight: theme.control.heightTouch,
              maxWidth: "100%",
              flexShrink: 1,
              paddingVertical: theme.space.xs,
              paddingHorizontal: theme.space.sm,
              borderRadius: theme.radius.control,
              borderWidth: checked ? 2 : 1,
              borderColor: checked ? theme.color.primary : theme.color.inputBorder,
              backgroundColor: checked ? theme.color.accentBg : theme.color.surface,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: theme.color.text,
                fontSize: 13,
                fontWeight: checked ? "700" : "500",
              }}
            >
              {checked ? `✓ ${reason.label}` : reason.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
